import { getRoute, apiSend } from "@services/axios";

export const postActivity = async (productId, activityData, level) => {
  if (![1, 2, 3].includes(level)) {
    throw new Error(`Invalid level: ${level}`);
  }
  localStorage.setItem("product_id_save", productId);
  var route = getRoute("create_activity_step_1");
  switch (level) {
    case 1:
      route = getRoute("create_activity_step_1");
      break;
    case 2:
      route = [getRoute("create_activity_step_2"), productId].join("/");
      break;
    case 3:
      route = [getRoute("create_activity_step_3"), productId].join("/");
      break;
    default:
      break;
  }

  try {
    const response = await apiSend(route, "post", activityData);

    return response.data.result;
  } catch (error) {
    console.error(`Error posting activity level ${level} (v2):`, error);
    throw error;
  }
};
